/************************* CONSTANTS *************************/
const modalDownloadNode = document.querySelector(".modal-download")
const downloadFileNode = document.querySelector("#download-file")
const modalUrlInputNode = document.querySelector("#modal-url-input")
const closeButtonNode = document.querySelector(".close-button")
const confirmDownloadNode = document.querySelector("#confirm-download")
const downloadFileFormNode = document.querySelector("#modal-download-file-form")
const modalEmailInputNode = document.querySelector("#modal-email-input")
const modalNameInputNode = document.querySelector("#modal-name-input")
const acceptSpecialOffersNode = document.querySelector("#modal-accept-special-offers")
const downloadMessageNode = document.querySelector("#download-message")
const loaderNode = document.querySelector("#loader")

/************************* FUNCTIONS *************************/
function toggleModal(e) {
  e.preventDefault()
  modalDownloadNode.classList.toggle("show-modal")
}

function windowOnClick(event) {
  if (event.target === modalDownloadNode) {
    toggleModal();
  }
}

function processDescription() {
  const descriptionNode = document.querySelector('.product-description[data-product-description]');
  const fileNode = (!descriptionNode.lastElementChild) ? descriptionNode : descriptionNode.querySelector("p:last-of-type")
  const url = fileNode.innerText.trim()
  fileNode.remove()
  downloadFileFormNode.setAttribute("action", url.trim())
  modalUrlInputNode.setAttribute("value", url.trim())
}

async function confirmedDownloaded(e) {
  const path = downloadFileFormNode.getAttribute("action").split("name=").pop()
  if(path !== "rdworks" && path !== "sagaonlaser" && path !== "ezcad2") e.preventDefault()
  modalDownloadNode.classList.toggle("show-modal")
  const email = modalEmailInputNode.value
  const name = modalNameInputNode.value
  const url = downloadFileFormNode.getAttribute("action")
  const acceptOffers = acceptSpecialOffersNode.checked
  fetch("https://jsfn-stech.azurewebsites.net/api/save/user", {
    method: "POST",
    body: JSON.stringify({email, name, url, acceptOffers })
  })
  .then(response => response.json())
  .then(response => console.log("Descargando archivo..."))
  .catch(error => console.error(`Ha ocurrido un error al guardar los datos: ${error.toString()}`))
  if(path !== "rdworks" && path !== "sagaonlaser" && path !== "ezcad2") await download(url)
  loaderNode.setAttribute("style", "display: none;")
  downloadMessageNode.setAttribute("style", "display: block;")
  downloadFileNode.removeAttribute("disabled")
}

/* Helper function */
async function download(url) {
  try {
    downloadMessageNode.setAttribute("style", "display: none;")
    loaderNode.setAttribute("style", "display: block;")
	downloadFileNode.setAttribute("disabled", "true")
    let response = await fetch(url, { method: "POST" })
    console.log(response)
    response = await response.json()
    console.log("La respuesta es: ", response)
    const bytes = JSON.parse(response.file).data
    console.log("Los bytes son: ", bytes)
    let base64data = btoa(new Uint8Array(bytes).reduce(function (data, byte) {
      return data + String.fromCharCode(byte)
    }, ''))
    let a = document.createElement('a')
    a.href = 'data:;base64,' + base64data
    a.download = response.filename
    a.click()
  } catch(error) {
    alert("Ha ocurrido un error al realizar la descarga, si el problema persiste contacte con soporte")
    console.log(error)
  }
}

/************************* LISTENERS *************************/
if(modalDownloadNode && downloadFileNode && closeButtonNode) { 
  document.addEventListener("DOMContentLoaded", processDescription)
  downloadFileNode.addEventListener("click", toggleModal)
  closeButtonNode.addEventListener("click", toggleModal)
  downloadFileFormNode.addEventListener("submit", confirmedDownloaded)
  window.addEventListener("click", windowOnClick)
}